import React, { useEffect, useState } from 'react'
import AdvancedSelect from './AdvancedSelect';
import { RECIPIENT_FILTER_OPERATORS } from '../../../../../../../consts/recipientFilter';
import { Divider } from '@livingdesign/react';
import { useRecipientFilter } from '../../../../../../../contexts/RecipientFilter';

export const QA_ID_PREFIX = "RFOperator";

function RFOperator({ index, operator }) {

    const {
        updateOperator,
        getIndexOfLastOperator,
        setAlertMessage,
        updateCriteria,
    } = useRecipientFilter();

    const [selectedOperator, setSelectedOperator] = useState(null);

    useEffect(() => {
        setSelectedOperator(RECIPIENT_FILTER_OPERATORS.find(op => op.value === operator));
    }, [operator]);

    useEffect(() => {
        if (selectedOperator) {
            updateOperator(index, selectedOperator.value);
        }
    }, [selectedOperator]);

    return (
        <>
            <div
                className='rf-condition'
                data-testid={`${QA_ID_PREFIX}-condition`}
            >
                <h3 data-testid={`${QA_ID_PREFIX}-condition-title`}>Condition</h3>
                <div
                    className='rf-condition-select'
                    data-testid={`${QA_ID_PREFIX}-condition-select`}
                >
                    <div
                        className='rf-condition-select-inner'
                        data-testid={`${QA_ID_PREFIX}-condition-select-inner`}
                    >
                        <AdvancedSelect
                            options={RECIPIENT_FILTER_OPERATORS}
                            isMulti={false}
                            searchable={false}
                            value={selectedOperator}
                            onChange={(values) => {
                                const lastOperatorIndex = getIndexOfLastOperator();
                                if(index < lastOperatorIndex) {
                                    setAlertMessage({
                                        show: true,
                                        title: "Invalid Operation",
                                        message: "You can only modify the last operator in the filter sequence.",
                                        cancelButtonText: "Close",
                                        confirmButtonText: "Okay",
                                        handleConfirm: () => setAlertMessage({ show: false })
                                    });
                                    return;
                                }
                                setSelectedOperator(values);
                                updateCriteria(index + 1, null, []);
                            }}
                            placeholder="Select operator"
                            data-testid={`${QA_ID_PREFIX}-attribute-value-select`}
                        />
                    </div>
                    {(selectedOperator?.value === "OR") ?
                        <Divider
                            UNSAFE_style={{ width: "calc(100% - 160px)"}}
                            data-testid={`${QA_ID_PREFIX}-divider`}
                        />
                        :
                        <div data-testid={`${QA_ID_PREFIX}-empty-divider`}></div>
                    }
                </div>
            </div>
        </>
    )
}

export default RFOperator;